export async function overlayShirtText(displayImage, shirtText, baseWidth, imageWidth, imageHeight) {
    return new Promise(async (resolve, reject) => {
      const textCanvas = document.createElement('canvas');
      const baseCanvas = document.createElement('canvas');
      const textCanvasContext = textCanvas.getContext('2d');
      const baseCanvasContext = baseCanvas.getContext('2d');
      const textImage = new Image();
      const baseImage = new Image();

      textCanvas.width = baseWidth;
      textCanvas.height = imageHeight;
  
      const loadImg = (img, src) => {
        return new Promise((resolve, reject) => {
          img.onload = () => {
            resolve(img);
            img.onload = null; // Clear the event listener
            img.onerror = null; // Clear the event listener
          };
          img.onerror = (error) => {
            reject(new Error(`Failed to load image with source: ${src}. Reason: ${error.message}`));
            img.onload = null; // Clear the event listener
            img.onerror = null; // Clear the event listener
          };
          img.src = src;
        });
      };
  
      try {
        await loadImg(baseImage, displayImage);
        baseCanvas.width = imageWidth;
        baseCanvas.height = imageHeight;
        baseCanvasContext.drawImage(baseImage, 0, 0);
  
        const textDataUrl = await createTextAsImageInternal(shirtText, baseWidth, imageHeight);
        await loadImg(textImage, textDataUrl);
        textCanvasContext.drawImage(textImage, 0, 0);
        baseCanvasContext.drawImage(textCanvas, 0, 0);
        
        resolve(baseCanvas.toDataURL());
      } catch (error) {
        reject(error);
      }
    });
}

export async function createTextAsImage(text, baseWidth, imageHeight) {
  const textCanvas = document.createElement('canvas');
  const textCanvasContext = textCanvas.getContext('2d');

  textCanvas.width = baseWidth;
  textCanvas.height = imageHeight;
  // Clear the canvas
  textCanvasContext.clearRect(0, 0, textCanvas.width, textCanvas.height);
  // Set the background color to transparent
  textCanvasContext.fillStyle = 'rgba(0, 0, 0, 0)';
  textCanvasContext.fillRect(0, 0, textCanvas.width, textCanvas.height);
  // Set the font and text alignment
  textCanvasContext.font = 'bold 25px Arial';
  textCanvasContext.textAlign = 'justify';
  textCanvasContext.fillStyle = 'black';

  // Set the text area dimensions
  const textAreaWidth = 165;
  const xPos = 235;
  const yPos = 495; 
  const lineHeight = 21;  

  drawText(textCanvasContext, text, xPos, yPos, textAreaWidth, lineHeight);

  // Convert the canvas to a data URL
  const dataUrl = textCanvas.toDataURL('image/png');

  // Set the data URL as the image URL
  return dataUrl;  
}


//===============================
// internal utility functions
//===============================
  async function createTextAsImageInternal(text, baseWidth, imageHeight) {
    const textCanvas = document.createElement('canvas');
    const textCanvasContext = textCanvas.getContext('2d');
  
    textCanvas.width = baseWidth;
    textCanvas.height = imageHeight;
    // Clear the canvas
    textCanvasContext.clearRect(0, 0, textCanvas.width, textCanvas.height);
    // Set the background color to transparent
    textCanvasContext.fillStyle = 'rgba(0, 0, 0, 0)';
    textCanvasContext.fillRect(0, 0, textCanvas.width, textCanvas.height);
    // Set the font and text alignment
    textCanvasContext.font = 'bold 25px Arial';
    textCanvasContext.textAlign = 'justify';
    textCanvasContext.fillStyle = 'black';
  
    // Set the text area dimensions
    const textAreaWidth = 165;
    const xPos = 235;
    const yPos = 495; 
    const lineHeight = 21;  
  
    drawText(textCanvasContext, text, xPos, yPos, textAreaWidth, lineHeight);
  
    // Convert the canvas to a data URL
    const dataUrl = textCanvas.toDataURL('image/png');
  
    // Set the data URL as the image URL
    return dataUrl;  
  }

  async function drawText(canvasContext, text, x, y, maxWidth, lineHeight) {
    let words = text.split(' ');
    let line = '';
  
    for (let n = 0; n < words.length; n++) {
      let testLine = line + words[n] + ' ';
      let metrics = canvasContext.measureText(testLine);
      let testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        let wordWidth = canvasContext.measureText(line).width;
        let offsetX = (maxWidth - wordWidth) / 2;
        canvasContext.fillText(line.trim(), x + offsetX, y);
        line = words[n] + ' ';
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
  
    let wordWidth = canvasContext.measureText(line).width;
    let offsetX = (maxWidth - wordWidth) / 2;
    canvasContext.fillText(line.trim(), x + offsetX, y);
  }  
  